import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { HrService } from 'src/app/services/hr/hr.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment';

@Component({
  selector: 'app-salary-month',
  templateUrl: './salary-month.component.html',
  styleUrls: ['./salary-month.component.css']
})
export class SalaryMonthComponent implements OnInit {

  constructor(private shiftService: HrService, private lookupService: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }


    SalaryModel = {
      MonthID: 0,
      SalaryMonth: '',
      StartDate:  moment(new Date()).format('DD-MMM-YYYY') ,
      EndDate:   moment(new Date()).format('DD-MMM-YYYY') ,
      SalYear:0,
      SalMonth:0,
      SalDays:0,      
      IsLock:false,
      IsActive:false,
  }

  Clear  () {
      this.SalaryModel.MonthID = 0;  
      this.SalaryModel.SalaryMonth = '';      
      this.SalaryModel.StartDate=moment(new Date()).format('DD-MMM-YYYY');
      this.SalaryModel.EndDate=moment(new Date()).format('DD-MMM-YYYY');
      this.SalaryModel.SalYear = 0;
      this.SalaryModel.SalMonth = 0;
      this.SalaryModel.SalDays = 0;
      this.SalaryModel.IsLock=false;
      this.SalaryModel.IsActive=false;
      this.Submitted = false;
  };

  Submitted=false;
  SaveSalaryMonth  (valid) {
      this.Submitted = true;
      if (valid) {
          this.spinnerService.show();
          this.SalaryModel.StartDate=this.SalaryModel.StartDate!=null && this.SalaryModel.StartDate!=''?moment(this.SalaryModel.StartDate).format('DD-MMM-YYYY'):'';
          this.SalaryModel.EndDate=this.SalaryModel.EndDate!=null && this.SalaryModel.EndDate!=''?moment(this.SalaryModel.EndDate).format('DD-MMM-YYYY'):'';
          this.shiftService.SaveSalaryMonth(JSON.stringify(this.SalaryModel)).subscribe( (response) =>{
            this.spinnerService.hide();
              if (response.webResponse.Status &&  this.SalaryModel.MonthID==0) {
                this.Clear();                              
              }
              if (response.webResponse.Status) {
                this.GetSalaryMonth();                
              }
              this.globalHelper.CheckActionStatus(response);
          });
      }
  };


SalaryMonthList:any;
GetSalaryMonth  () {
  this.spinnerService.show();
      this.shiftService.GetSalaryMonth().subscribe( (data) =>{
        this.spinnerService.hide();
        this.SalaryMonthList = data.SalaryMonthList;        
         
      });
  };


 Edit  (obj) {
      this.SalaryModel.MonthID = obj.MonthID;
      this.SalaryModel.SalaryMonth = obj.SalaryMonth;
      this.SalaryModel.StartDate=obj.StartDate!=null && obj.StartDate!=''?moment(obj.StartDate).format('DD-MMM-YYYY'):'';
      this.SalaryModel.EndDate=obj.EndDate!=null && obj.EndDate!=''?moment(obj.EndDate).format('DD-MMM-YYYY'):'';
      this.SalaryModel.SalYear = obj.SalYear;
      this.SalaryModel.SalMonth = obj.SalMonth;
      this.SalaryModel.IsLock = obj.IsLock;
      this.SalaryModel.SalDays = obj.SalDays;
     
  };

 
  SalaryMonthMarkActive(item) {
    
    this.SalaryModel.MonthID = item.MonthID;
    this.SalaryModel.IsLock = item.IsLock == true ? false : true;
    this.shiftService.SalaryMonthMarkActive(this.SalaryModel.MonthID,this.SalaryModel.IsLock).subscribe((data: any) => {
      if (data.webResponse.Status) {
       this.GetSalaryMonth();
      }
      this.globalHelper.CheckActionStatus(data);
    });
  
  };
  ngOnInit() {
    this.GetSalaryMonth();
  }

}
